import React, { useState } from "react";

const ResetPassword = () => {
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const toggleNewPasswordVisibility = () => {
    setNewPasswordVisible(!newPasswordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  return (
    <section className="auth d-flex">
      {/* Left Section */}
      <div className="auth-left bg-main-50 flex-center p-24">
        <img
          src="assets/images/thumbs/auth-img3.png"
          alt="Reset Password Illustration"
        />
      </div>

      {/* Right Section */}
      <div
        className="auth-right py-40 px-24 flex-center flex-column"
        style={{ backgroundColor: "white" }}
      >
        <div className="auth-right__inner mx-auto w-100">
          <a href="index.html" className="auth-right__logo">
            <img src="assets/images/logo/logo.png" alt="Logo" />
          </a>
          <h2 className="mb-8">Reset Password</h2>
          <p className="text-gray-600 text-15 mb-32">
            For <span className="fw-medium">exampleinfo@mail.com</span>
          </p>

          {/* Form */}
          <form>
            <div className="mb-24">
              <label htmlFor="new-password" className="form-label mb-8 h6">
                New Password
              </label>
              <div className="position-relative">
                <input
                  type={newPasswordVisible ? "text" : "password"}
                  className="form-control py-11 ps-40"
                  id="new-password"
                  placeholder="Enter New Password"
                />
                <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                  <i className="ph ph-lock"></i>
                </span>
                <span
                  className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y"
                  onClick={toggleNewPasswordVisibility}
                >
                  {newPasswordVisible ? (
                    <i className="ph ph-eye"></i>
                  ) : (
                    <i className="ph ph-eye-slash"></i>
                  )}
                </span>
              </div>
            </div>
            <div className="mb-24">
              <label htmlFor="confirm-password" className="form-label mb-8 h6">
                Confirm Password
              </label>
              <div className="position-relative">
                <input
                  type={confirmPasswordVisible ? "text" : "password"}
                  className="form-control py-11 ps-40"
                  id="confirm-password"
                  placeholder="Enter Confirm Password"
                />
                <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                  <i className="ph ph-lock"></i>
                </span>
                <span
                  className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {confirmPasswordVisible ? (
                    <i className="ph ph-eye"></i>
                  ) : (
                    <i className="ph ph-eye-slash"></i>
                  )}
                </span>
              </div>
            </div>

            <button type="submit" className="btn btn-main rounded-pill w-100">
              Set New Password
            </button>

            <a
              href="sign-in.html"
              className="mt-24 text-main-600 flex-align gap-8 justify-content-center"
            >
              <i className="ph ph-arrow-left d-flex"></i> Back To Login
            </a>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
